<script>
    import {onMount} from 'svelte';
    import { fade } from 'svelte/transition';
    import {
        DynamicTranslatedApp,
    } from "svelte-translate";
    import isLoading from '../stores/loading-store';
    import LoadingSpinner from '../../components/loading-spinner.svelte';
    import Header from './event-reservation-header.svelte';
    import {steps} from "../stores/reservation-store";
    import BirthdayStep1 from './birthday-step1.svelte';
    import BirthdayStep2 from './birthday-step2.svelte';
    import BirthdayStep3 from './birthday-step3.svelte';
    import BirthdayStep4 from './birthday-step4.svelte';
    import BirthdayStep5 from './birthday-step5.svelte';
    import getLang from "../../utils/get-lang";
</script>
<DynamicTranslatedApp
    fallbackLanguage="en"
    initialLanguage={getLang()}
    hideContentWhileLoading={true}>
    <Header />
    {#if $steps.currentStep === 1}
<main class="container dropped--heavy">
    <BirthdayStep1 />
</main>

{:else if $steps.currentStep === 2}
<main class="container dropped--medium">
    <BirthdayStep2 />
</main>

{:else if $steps.currentStep === 3}
<main class="container dropped--medium">
    <BirthdayStep3 />
</main>

{:else if $steps.currentStep === 4}
<main class="container dropped--medium">
    <BirthdayStep4 />
</main>

{:else if $steps.currentStep === 5}
<main class="container dropped--medium">
    <BirthdayStep5 />
</main>

{:else}
<main class="container dropped--heavy">
    Error loading reservation content.
</main>
{/if}

{#if $isLoading}<LoadingSpinner />{/if}
</DynamicTranslatedApp>
